module.exports = __webpack_public_path__ + "img/9-3.49395de5.jpg";